import { VueCharts, mixins } from 'vue-chartjs';
import * as _ from 'lodash';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';

const { reactiveProp } = mixins;

const barchartData = {
  labels: ['Industry Average', 'Industry Best', 'Industry Worst', '', ''],
  datasets: [
    {
      label: '',
      backgroundColor: '#FFFFFF',
      data: [0, 0, 0, 0, 0, 0, 0],
      datalabels: {
        formatter() {
          return '';
        }
      }
    },
    {
      label: 'Overall',
      backgroundColor: '#008001',
      data: [0, 0, 0, 0, 0, 0, 0],
      datalabels: {
        anchor: 'start',
        align: 'top',
        color: '#000000',
        font:{
          size: '13'
        },
        formatter(value) {
          return value > 0 ? parseFloat(value).toFixed(2) : '';
        }
      }
    },
    {
      label: 'Industry Average',
      backgroundColor: '#000000',
      fontStyle: 'bold',
      data: [0, 0, 0, 0, 0, 0, 0],
      datalabels: {
        anchor: 'start',
        align: 'top',
        color: '#ffffff',
        font:{
          size: '13'
        },
        formatter(value) {
          return value > 0 ? parseFloat(value).toFixed(2) : '';
        }
      }
    },
    {
      label: 'Industry Best',
      backgroundColor: '#558ED5',
      data: [0, 0, 0, 0, 0, 0, 0],
      datalabels: {
        anchor: 'start',
        align: 'top',
        color: '#ffffff',
        font:{
          size: '13'
        },
        formatter(value) {
          return value > 0 ? parseFloat(value).toFixed(2) : '';
        }
      }
    },
    {
      label: 'Industry Worst',
      backgroundColor: '#FE0000',
      data: [0, 0, 0, 0, 0, 0, 0],
      datalabels: {
        anchor: 'start',
        align: 'top',
        color: '#ffffff',
        font:{
          size: '13'
        },
        formatter(value) {
          return value > 0 ? parseFloat(value).toFixed(2) : '';
        }
      }
    },
    {
      label: '1st Gear',
      backgroundColor: '#FF0000',
      data: [0, 0, 0, 0, 0, 0, 60],
      datalabels: {
        anchor: 'center',
        offset: '-30',
        align: 'start',
        color: '#000000',
        font:{
          family: "Stag-Black",
          size: "18"
        },
        formatter(value) {
          return value > 0 ? '1st Gear' : '';
        }
      }
    },
    {
      label: '2nd Gear',
      backgroundColor: '#FF9D5B',
      data: [0, 0, 0, 0, 0, 0, 10],
      datalabels: {
        anchor: 'center',
        offset: '-15',
        align: 'start',
        color: '#000000',
        font:{
          family: "Stag-Black",
          size: "18"
        },
        formatter(value) {
          return value > 0 ? '2nd Gear' : '';
        }
      }
    },
    {
      label: '3rd Gear',
      backgroundColor: '#FFE161',
      data: [0, 0, 0, 0, 0, 0, 10],
      datalabels: {
        anchor: 'center',
        align: 'start',
        offset: '-15',
        color: '#000000',
        font:{
          family: "Stag-Black",
          size: "18"
        },
        formatter(value) {
          return value > 0 ? '3rd Gear' : '';
        }
      }
    },
    {
      label: '4th Gear',
      backgroundColor: '#92D050',
      data: [0, 0, 0, 0, 0, 0, 20],
      datalabels: {
        anchor: 'center',
        offset: '-15',
        align: 'start',
        color: '#000000',
        font:{
          family: "Stag-Black",
          size: "18"
        },
        formatter(value) {
          return value > 0 ? '4th Gear' : '';
        }
      }
    }
  ]
};


export default {
  extends: VueCharts.Bar,
  components: {
    ChartJsPluginDataLabels
  },
  mixins: [reactiveProp],
  props: ['chartData', 'surveyRuns'],
  watch: {
    chartData: {
      handler(newData) {
        if (newData) this.draw();
      }
    },
    surveyRuns: {
      handler() {
        this.draw();
      }
    }
  },
  mounted() {
    this.addPlugin({
      beforeDraw(chartInstance) {
        const ctx = chartInstance.chart.ctx; // eslint-disable-line prefer-destructuring
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
      }
    });
    if (this.chartData) this.draw();
  },
  methods: {
    draw() {
      const newChartData = _.cloneDeep(barchartData);

      // different programmes, different colors
      //different programmes, different colors/fonts
      if (this.surveyRuns[0].programmeName === "CoR Culture") {
        newChartData.datasets[5].backgroundColor = '#0A133D';
        newChartData.datasets[5].datalabels.font.family = 'Calibri';
        newChartData.datasets[5].datalabels.color = '#FFFFFF';
        newChartData.datasets[5].label = '1st';
        newChartData.datasets[5].datalabels.formatter = (value) => value > 0 ? '1st' : '';
        newChartData.datasets[6].backgroundColor = '#6ABF3D';
        newChartData.datasets[6].datalabels.font.family = 'Calibri';
        newChartData.datasets[6].datalabels.color = '#FFFFFF';
        newChartData.datasets[6].label = '2nd';
        newChartData.datasets[6].datalabels.formatter = (value) => value > 0 ? '2nd' : '';
        newChartData.datasets[7].backgroundColor = '#A5A5A5';
        newChartData.datasets[7].datalabels.font.family = 'Calibri';
        newChartData.datasets[7].datalabels.color = '#FFFFFF';
        newChartData.datasets[7].label = '3rd';
        newChartData.datasets[7].datalabels.formatter = (value) => value > 0 ? '3rd' : '';
        newChartData.datasets[8].backgroundColor = '#0A81D1';
        newChartData.datasets[8].datalabels.font.family = 'Calibri';
        newChartData.datasets[8].datalabels.color = '#FFFFFF';
        newChartData.datasets[8].label = '4th';
        newChartData.datasets[8].datalabels.formatter = (value) => value > 0 ? '4th' : '';
      }

      newChartData.datasets.forEach(dataset => dataset.data = _.fill(new Array(this.surveyRuns.length + 6), 0));

      const sameYear = _.uniq(this.surveyRuns.map(surveyRun => surveyRun.year)).length === 1;
      const samePeriod = _.uniq(this.surveyRuns.map(surveyRun => surveyRun.period)).length === 1;

      const newLabels = [];
      //labels
      this.surveyRuns.forEach((surveyRun, index) => {
        newLabels.push(`Overall ${(!sameYear || !samePeriod) ? `${surveyRun.period} ${surveyRun.year}`: ''}`.trim());
        newChartData.datasets[1].data[index + 1] = surveyRun.overallScore;
      });
      for(let i = newLabels.length - 1; i >= 0; i--) {
        newChartData.labels.unshift(newLabels[i]);
      }
      newChartData.labels.unshift('');

      newChartData.datasets[2].data[this.surveyRuns.length + 1] = this.chartData.overall.average;
      newChartData.datasets[3].data[this.surveyRuns.length + 2] = this.chartData.overall.maximum;
      newChartData.datasets[4].data[this.surveyRuns.length + 3] = this.chartData.overall.minimum;
      newChartData.datasets[5].data[newChartData.datasets[5].data.length - 1] = 60;
      newChartData.datasets[6].data[newChartData.datasets[6].data.length - 1] = 10;
      newChartData.datasets[7].data[newChartData.datasets[7].data.length - 1] = 10;
      newChartData.datasets[8].data[newChartData.datasets[8].data.length - 1] = 20;

      if (!this.surveyRuns) {
        newChartData.datasets[2].data.splice(1,1);
        newChartData.datasets[3].data.splice(1,1);
        newChartData.datasets[4].data.splice(1,1);
        newChartData.datasets[5].data.splice(1,1);
        newChartData.datasets[6].data.splice(1,1);
        newChartData.datasets[7].data.splice(1,1);
        newChartData.datasets[8].data.splice(1,1);
        newChartData.labels.splice(1,1);
        newChartData.datasets.splice(1,1);

      }


      // now render!
      this.renderChart(newChartData, {
        events:[],
        responsive: false,
        maintainAspectRatio: true,
        title: {
          display: false,
          text: 'Chart.js Bar Chart - Stacked'
        },
        legend: false,
        layout: {
          padding: {
            right: 0
          }
        },
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              display: true,
              fontStyle: 'bold',
              fontColor: 'black',
              fontSize: 12,
              autoSkip: false
            },
            gridLines: {
              display: false
            }
          },
          {
            position: 'top',
            ticks: {
              display: false
            },
            gridLines: {
              display: false,
              lineWidth: 1,
              drawBorder: false,
              drawOnChartArea: true,
              color: '#000000',
              drawTicks: false,
              borderDashOffset: -10,
              zeroLineBorderDash: [this.width - 100, this.width - 100],
              zeroLineBorderDashOffset: -10,
              borderDash: [this.width - 100, this.width - 100]
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              display: true, min: 0, max: 100, stepSize: 10, fontColor: '#000000',
              fontColor: 'black'
            },
            scaleLabel: {
              display: true,
              labelString: 'Percentage',
              fontColor: '#000000'
            },
            gridLines: {
              display: true,
              color: '#000000',
              lineWidth: 1,
              borderDashOffset: -10,
              zeroLineColor: '#000000',
              zeroLineBorderDash: [this.width - 77, this.width - 100],
              zeroLineBorderDashOffset: -10,
              borderDash: [this.width - 78, this.width - 100],
              drawBorder: false,
              drawOnChartArea: true,
              drawTicks: false
            }
          }
          ]
        },
        showTooltips: false,
        plugins: {
          datalabels: {
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/graphs/GearIndustryBar.js